import Vue from 'vue'
import AppShell from './app-shell/AppShell.vue'
// import VueGtag from 'vue-gtag'
import VueGtm from 'vue-gtm'

// Vue.use(VueGtag, {
//   config: { id: 'UA-41579532-4' }
// })

Vue.config.productionTip = false

// Ignore Airship components
Vue.config.ignoredElements = [/as-\w+/]

// Error handler
window.onerror = (message, source, lineno, colno, error) => {
  // message: error message (string). Available as event (sic!) in HTML onerror="" handler.
  // source: URL of the script where the error was raised (string)
  // lineno: Line number where error was raised (number)
  // colno: Column number for the line where the error occurred (number)
  // error: Error Object (object)
  onError({
    err: message,
    source,
    info: `in line ${lineno}:${colno}`
  })
}

Vue.config.errorHandler = (err, vm, info) => {
  // err: error trace
  // vm: component in which error occured
  // info: Vue specific error information such as lifecycle hooks, events etc.
  onError({
    err,
    source: vm,
    info
  })
}

const requireComponent = require.context(
  './components/common',
  true,
  /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)
  const componentName = fileName.split('/').pop().replace(/\.\w+$/, '')
  // Register component globally
  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
})

export class FundacionTelefonicaEmployment {
  constructor (id, {
    config,
    data,
    component
  } = {}) {
    this.graph_version = 'version:2.0.3'
    this.id = id
    this.config = config
    this.data = data
    this.component = component
    //const _enabled = !!(this.config.analytics.consent !== '' && window[this.config.analytics.consent]())
    const _enabled = true
    const _loadscript = !!(this.config.analytics.loadScript || !window.dataLayer)

    Vue.use(VueGtm, {
      id: this.config.analytics.gtmID,
      enabled: _enabled,
      debug: false,
      loadScript: _loadscript
    })

    try {
      this.checkErrors()
      this.render()
    } catch (error) {
      this.renderError(error)
      throw error
    }
  }

  checkErrors () {
    if (!this.id) {
      throw Error('Id is required')
    }
    if (!this.config) {
      throw Error('Config is required')
    }
    if (!this.data) {
      throw Error('Data is required')
    }
    if (!this.component) {
      throw Error('Component is required')
    }
  }

  render () {
    this.instance = new Vue({
      data: {
        id: this.id,
        config: this.config,
        data: this.data,
        component: this.component
      },
      render: h => h(AppShell)
    }).$mount(this.id)
  }

  renderError (error) {
    const el = document.getElementById(this.id.split('#')[1])

    const div = document.createElement('div')
    div.style.width = '100%'
    div.style.height = '100%'
    div.style.display = 'flex'
    div.style.justifyContent = 'center'
    div.style.alignItems = 'center'
    div.style.backgroundColor = '#9c9b9b'
    div.style.color = '#fff'
    div.innerText = error.toString()
    el.append(div)
  }
}

window.FundacionTelefonicaEmployment = FundacionTelefonicaEmployment

function onError ({ err, source, info }) {
  /* eslint-disable */
  console.error('Error: ', err)
  console.error('Source: ', source)
  console.error('Extra info: ', info)
  /* eslint-enable */
}
